module.exports = __webpack_public_path__ + "d5c112e93782ccc996285fc355189c7b.png";